import React, { useEffect, useRef, useState } from "react";
import {
  EVENT_UI_STATUS_OPTIONS,
  formatEventStatusFilterLabel,
} from "../shared/utils/eventOpenClosedStatus";

/**
 * Multi-select Status filter: All / Open / Expired / Closed (Event Management tabs).
 * @param {Set<string>} value
 * @param {(next: Set<string>) => void} onChange
 * @param {boolean} [disabled]
 */
export default function EventStatusFilterDropdown({ value, onChange, disabled = false }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const statusFilter = value instanceof Set ? value : new Set();

  useEffect(() => {
    if (disabled) setOpen(false);
  }, [disabled]);

  useEffect(() => {
    if (!open) return undefined;
    function handleClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  function toggleOption(label, checked) {
    const next = new Set(statusFilter);
    if (checked) next.add(label);
    else next.delete(label);
    onChange(next);
  }

  return (
    <div className="toolbar-filter-group">
      <span className="toolbar-label">Status:</span>
      <div ref={ref} className="dropdown-wrap">
        <button
          type="button"
          onClick={() => {
            if (disabled) return;
            setOpen(!open);
          }}
          className="dropdown-trigger"
          disabled={disabled}
          aria-disabled={disabled}
          style={
            disabled
              ? { background: "#f1f3f5", cursor: "not-allowed", opacity: 1 }
              : undefined
          }
        >
          <span>{formatEventStatusFilterLabel(statusFilter)}</span>
          <span className="dropdown-arrow">{open ? "▲" : "▼"}</span>
        </button>
        {open && !disabled ? (
          <div className="dropdown-panel">
            <label className="dropdown-option">
              <input
                type="checkbox"
                checked={statusFilter.size === 0}
                onChange={() => onChange(new Set())}
              />
              <span>All</span>
            </label>
            {EVENT_UI_STATUS_OPTIONS.map((label) => (
              <label key={label} className="dropdown-option">
                <input
                  type="checkbox"
                  checked={statusFilter.has(label)}
                  onChange={(e) => toggleOption(label, e.target.checked)}
                />
                <span>{label}</span>
              </label>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
}
